import React from 'react';
import styled from 'styled-components';
import { textSize, marginLevel } from '@styles';

export const Title = ({ align = 'center', html, marginLevel = 'dark_cream', marginDirection = 'bottom', children }) => (
  <>
    {html ? (
      <View
        align={align}
        marginLevel={marginLevel}
        marginDirection={marginDirection}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    ) : (
      <View marginLevel={marginLevel} align={align}>
        {children}
      </View>
    )}
  </>
);

export const View = styled.h1`
  ${textSize('block_header')};
  font-weight: 200;
  width: 100%;
  text-align: ${(p) => p.align};
  ${(p) => marginLevel(p.marginDirection, p.marginLevel)}
`;
